import React, {useEffect, useState, useRef} from 'react';
import {useDispatch} from "react-redux";

import {ThankYouCopy} from "_components/ThankYouCopy/ThankYouCopy";
import {ThankYouActionButtons} from "_components/ActionButtons/ThankYouActionButtons";
import {updateEntry} from "_features/entries/entry-slice";

import {
    empty,
    logIt,
} from "__globals/global-functions";

import {
    checkDateVariations
} from "__globals/date-functions";

import * as GC from '__globals/GLOBAL-CONSTANTS.js';


export const ThankYouECoupon = props => {

    const dispatch = useDispatch();

    logIt( GC.TY_ECARD + " PAGE IS CALLED", null, false );

    const RESULT_KEY = GC.TY_ECOUPON; // for the title and copy

    /** Sets the result css from the game claim */
    useEffect(() => {
        if ( !empty(props.gameClaim) ) {

            if (!props.gameClaim.losing) {
                let cStart = "";
                if (!empty(props.gameClaim.parameters["couponStartDate"])) {
                    cStart = props.gameClaim.parameters["couponStartDate"];
                }
                let fDate = checkDateVariations(cStart);
                if (checkDateVariations !== false) {
                    cStart = fDate;
                }
                let cEnd = "";
                if (!empty(props.gameClaim.parameters["couponEndDate"])) {
                    cEnd = props.gameClaim.parameters["couponEndDate"];
                }
                let pWon = props.gameClaim.parameters["prizeWon"];
                let addEntryObj = {
                    entry: {
                        "couponStartDate": cStart,
                        "couponEndDate": cEnd,
                        "prizeWon": pWon
                    }
                }
                if ( props.gameClaim !== undefined && props.gameClaim.parameters.emailSend !== undefined) {
                    if ( !props.entryUpdated ) {
                        let emailSend = {};
                        emailSend.emailTemplate = props.gameClaim.parameters.emailSend.emailTemplate;
                        emailSend.emailSubject = props.gameClaim.parameters.emailSend.emailSubject;
                        dispatch( updateEntry( addEntryObj, emailSend ) );
                    }
                } else {
                    dispatch( updateEntry( addEntryObj ) );
                }
            }
        }
    }, [props.gameClaim]);


    // RETURN THE GAME RESULT
    return (
        <div id='dv_thank_you_e_coupon' >

            <ThankYouCopy
                promotion={props.promotion}
                gameClaim={props.gameClaim}
                configKey={"thankYouScreen"}
                jsonKey={GC.TY_ECOUPON}
                entry={props.entry}
            />

            <ThankYouActionButtons
                promotion={props.promotion}
                gameClaim={props.gameClaim}
                jsonKey={RESULT_KEY}
                doAction={props.doAction}
            />

        </div>
    );
}

export default ThankYouECoupon;